import { Parameters } from '../../parameters/type/parameters.type';
import { Filters } from '../../parameters/type/filter.type';

export class InitAnalyse {
  static readonly type = '[Analyse] Init';
}

export class SendParameters {
  static readonly type = '[Import] Send Parameters';
  constructor(public parameters: Parameters[]) {}
}

export class AnalyseBreadcrumbAction {
  static readonly type = '[Analyse] Breadcrumb Action';
  constructor(public step: number) {}
}

export class GetRowFromSelectedField {
  static readonly type = '[Analyse] Get Row From Selected Field';
  constructor(public field: string) {}
}

export class GetJsonFile {
  static readonly type = '[Analyse] Get JSON File';
  constructor(public field: string) {}
}

export class SendFilter {
  static readonly type = '[Lever] Send Filter';

  constructor(public field: Filters) {}
}

